<div class="relative overflow-x-auto @max-w-32 @sm:w-full">
  <table class="@min-w-64 w-full text-sm text-left rtl:text-right text-gray-500">
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <th scope="col" class="px-1 py-2 w-1/6">Language</th>
        <th scope="col" class="px-1 py-2 w-5/6">State of Translation(s)</th>
      </tr>
    </thead>
    <tbody>
      @for (translationLanguage of translationStatistics; track $index) {
        <tr class="bg-white border-b border-gray-200">
          <td class="px-1 py-1 text-gray-700 whitespace-nowrap align-top">
            <span>{{ translationLanguage.languageCode }}</span>
          </td>
          <td class="px-1 py-1 relative group align-top">
            <div class="flex flex-col gap-4 w-full">
              <div class="flex h-[20px] border-0 rounded-md overflow-hidden">
                @for (state of translationLanguage.states; track $index) {
                  <div
                    class="h-full transition-all duration-300"
                    [style.width]="state.percent + '%'"
                    [ngClass]="commonUtils.translationStateToColor(state.translationState)"
                    title="{{ commonUtils.friendlyTranslationState(state.translationState) }}{{
                      translationLanguage.total > 1 ? ': ' + state.count : ''
                    }}"
                  ></div>
                }
              </div>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
